export const TALK_AND_FOLKLOR_DATE = "15.11.2025";
export const TRIP_DATE = "16.11.2025";
